import React, { useEffect, useState } from 'react';
import imgIcon from '../../assets';
import { Buttons } from '../../common/Buttons';
import PendingIcon from '@mui/icons-material/Pending';
import '../Styles/Payment.css';
import { IconDetalis } from '../../common/IconDetalis';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate } from 'react-router-dom';
import { LeftRightlayout } from '../Container/LeftRightlayout';
import { buttonClass, Icon } from '../../common/CSS';
import { Header } from '../Container/Header';
import { useDispatch, useSelector } from 'react-redux';
import config from '../../config';
import { useContext } from 'react';
import FormContextApi from '../../ContextApi';
import { createIndependentTickets } from '../../actions/tickets';
import { openCustomModal } from '../../actions/modal';
import AddIcon from '@mui/icons-material/Add';
import { addAmountToWallet, getWalletDetails } from '../../actions/wallet';
import { GstNumberModal } from '../Modal/GstNumberModal';
import { IconButton, Tooltip } from '@mui/material';
import { gtag } from 'ga-gtag';

export default function Payment() {
    const { ticketdata, access, setaccess, walletValue } = useContext(FormContextApi);
    const { user } = useSelector((store) => store.userreducer);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [btnDisable, setBtnDisable] = useState(true);
    const formName = 'paymentForm';
    const addMoneyBtn = 'addMoneyBtn';
    let { formButtonLoading } = useSelector((store) => store.loadingreducer);
    const { ongoingTransaction, wallet } = useSelector((store) => store.walletreducer);

    if (ticketdata?.data === '' || access?.pageacces) {
        navigate('/service');
    }

    useEffect(() => {
        document.title = 'Payment';
    }, []);

    const openGstModal = () => {
        dispatch(
            openCustomModal({
                modalComponent: <GstNumberModal setaccess={setaccess} customer_id={user?.customer_id} />,
                heading: 'Add Your GST Details',
                modalWidth: '45rem',
                modalHeight: 'auto',
            })
        );
    };

    const walletBalance = () => {
        if (!wallet?.wallet_amount) {
            if (wallet?.loan_amount > 0) {
                return <p className='text-scogodarkRed'>- {wallet?.loan_amount}</p>;
            } else {
                return wallet?.wallet_amount;
            }
        } else {
            return wallet?.wallet_amount;
        }
    };

    const onClickHandler = () => {
        const data = ticketdata?.ticketdata;
        const file = ticketdata?.file;
        dispatch(
            createIndependentTickets({
                data,
                existing: true,
                addNew: false,
                refresh: false,
                type: 2,
                formName: formName,
                navigate,
                file,
                setgtag: () => {
                    gtag('event', 'Click', {
                        IndependentTickets: 'button',
                    });
                },
            })
        );
        setaccess({ pageacces: false, paymentacces: true, gstModal: 'stop' });
    };

    const addMoney = () => {
        let money = wallet?.wallet_amount >= walletValue ? walletValue : walletValue - wallet?.wallet_amount;
        setaccess({ pageacces: false, paymentacces: true, gstModal: 'stop' });
        dispatch(addAmountToWallet({ orderAmount: money + 432, formName: addMoneyBtn }));
    };

    useEffect(() => {
        if (wallet?.wallet_amount >= walletValue) {
            setBtnDisable(false);
        } else if (wallet?.wallet_amount === undefined) {
            dispatch(getWalletDetails({ updateBalance: true }));
        }
    }, [wallet, dispatch]);

    useEffect(() => {
        if (access?.gstModal === true) {
            openGstModal();
        } else {
            payment();
        }
    }, [ongoingTransaction?.token]);

    const payment = () => {
        if (ongoingTransaction && window?.Layer && access?.paymentacces && ongoingTransaction?.token) {
            window?.Layer?.checkout(
                {
                    token: ongoingTransaction?.token,
                    accesskey: config.bankopen.accessKey,
                },
                function (response) {
                    if (response.status === 'captured') {
                        dispatch(getWalletDetails({ updateBalance: true }));
                        setBtnDisable(false);
                        setaccess({ pageacces: false, paymentacces: false });
                        gtag('event', 'Click', {
                            moneyAddtoWallet: 'button',
                        });
                    } else if (response.status === 'created') {
                        console.log(response);
                    } else if (response.status === 'pending') {
                        console.log(response);
                    } else if (response.status === 'failed') {
                        console.log(response);
                    } else if (response.status === 'cancelled') {
                        setaccess({ pageacces: false, paymentacces: false });
                    }
                },
                function (err) {
                    console.log(err);
                }
            );
        }
    };

    const Content = () => {
        return (
            <>
                <Header showButton path='/service' />
                <div className='mt-4 '>
                    <div className={Icon.HeadingIcon}>
                        <IconDetalis coloreIcon='text-darkblue' IconName='manage_accounts' IconHeading='Your Details' />
                        <IconDetalis coloreIcon='text-darkblue' IconName='devices' IconHeading='Select Service' />
                        <IconDetalis coloreIcon='text-darkblue' IconName='currency_rupee' IconHeading='Payment' />
                        <IconDetalis coloreIcon='text-stardust' IconName='engineering' IconHeading='Get Engineer' />
                        <div className='w-110F rounded-none bg-darkblue h-3P mt-3 checkBox'>
                            <CheckCircleIcon />
                        </div>
                        <div className='w-110F rounded-none bg-darkblue h-3P mt-3 checkBox'>
                            <CheckCircleIcon />
                        </div>
                        <div className='w-110F rounded-none bg-darkblue h-3P mt-3 checkBoxPanding'>
                            <PendingIcon />
                        </div>
                        <div className='w-full rounded-none bg-stardust h-3P mt-3'></div>
                    </div>
                </div>

                <div className='w-11/12 p-2 m-auto'>
                    <h1 className='text-22F mt-4 font-medium'>Make A Payment</h1>

                    <h1 className='text-28F mt-4 text-center'>Your Wallet Details</h1>
                    <div
                        className='border border-solid rounded-md w-auto py-2 mt-6 text-center text-scogoprimary'
                        style={{
                            boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px',
                        }}
                    >
                        <p className='text-4xl mt-3 '>₹</p>
                        <p className='text-4xl mt-3 font-semibold'>{walletBalance()}</p>
                        <p className='text-xl mt-3 mb-3'>Current Balance</p>
                    </div>
                    <p
                        className='text-14F mt-3 mb-3 flex items-center gap-x-2'
                        style={{
                            width: '101%',
                        }}
                    >
                        Your wallet should have minimum Rs.{walletValue} + 18%GST to book a ticket
                        <Tooltip
                            title={
                                <div
                                    className='text-16F grid gap-x-4 gap-y-3 justify-between w-52 pr-2'
                                    style={{
                                        gridTemplateColumns: '70% 30%',
                                    }}
                                >
                                    <p>Ticket base price</p>
                                    <p>₹ 2400</p>

                                    <p>GST (9% + 9% )</p>
                                    <p>₹ 432 </p>

                                    <hr className='col-span-2 mr-2' />
                                    <p>Grant Total </p>
                                    <p> ₹ 2832</p>
                                </div>
                            }
                            placement='right-start'
                            arrow
                            style={{
                                padding: '0px',
                            }}
                        >
                            <IconButton>
                                <span className='material-icons text-20F text-slate-700 cursor-pointer '>info</span>
                            </IconButton>
                        </Tooltip>
                    </p>
                    <div className='text-right mt-2'>
                        <Buttons
                            loading={formButtonLoading?.[addMoneyBtn]}
                            onClick={() => addMoney()}
                            btnText='Add Money'
                            classN={`${buttonClass?.scogoTransparentBtn} pt-2 pb-8 mr-3 text-17F `}
                            Iconbefore={<AddIcon className='pr-1 AddIcon font-black' />}
                        />
                    </div>

                    <div className='w-11/12 mt-8'>
                        <h1 className='text-22F mt-4 font-medium'>Note</h1>
                        <div className='mt-2'>
                            <p className='text-lg'>
                                In case of payment failure or amount not reflecting in wallet, reach out to our helpline no: +91-7987630890 or drop an email to support@scogo.in .
                            </p>
                        </div>
                    </div>

                    <div className='w-11/12 absolute bottom-12 right-6 getEngineer'>
                        <Buttons
                            loading={formButtonLoading?.[formName]}
                            disabled={btnDisable}
                            btnText='Get Engineer'
                            onClick={() => onClickHandler()}
                            classN={'bg-scogoOrange shadow-subBtnShadow border border-scogoOrange rounded-sm text-white text-base w-full m-auto pt-2 pb-2'}
                        />
                    </div>
                </div>
            </>
        );
    };

    const Imgsection = () => {
        return (
            <div className='m-auto h-5/6 w-68P'>
                <img width='100%' className='m-auto h-5/6 mt-16' src={imgIcon.Payment} alt='' />
            </div>
        );
    };

    return (
        <>
            <LeftRightlayout Content={Content} RightImg={Imgsection} />
        </>
    );
}
